<template>
    <v-row dense>
        <v-col cols="12" md="12">
            <v-card variant="outlined">
                <v-card-title>
                    <span class="font-weight-bold text-subtitle-2">
                        {{ $t('terms_of_use') }}
                    </span>
                </v-card-title>
                <v-card-text class="text-body-1">
                    <v-row dense>
                        <v-col cols="12">
                            <div>
                                {{ $t('discount_terms.apply_if') }}
                            </div>
                            <div class="d-inline-flex flex-wrap align-center">
                                <div class="me-2">
                                    {{ $t('discount_terms.days_more') }}
                                </div>
                                <v-number-input
                                    v-model="discountTerms.daysPrior"
                                    :max="360"
                                    :min="0"
                                    hide-details
                                    class="me-2 my-2"
                                    :step="1"
                                />
                                <div>
                                    {{ $t('discount_terms.days_prior_to') }}
                                </div>
                            </div>
                            <div class="mb-2">
                                {{ $t('discount_terms.and_also') }}
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <span>{{ $t('booking_occurs_at') }}</span>
                            <div class="d-flex align-center flex-column flex-md-row full-width py-4">
                                <div class="me-md-4 mb-4 mb-md-0 full-width">
                                    <date-picker
                                        v-model="discountTerms.bookingDateFrom"
                                        :max="discountTerms.dateTo || '2100-01-01'"
                                        :label="$t('date_from')"
                                        hide-details
                                    />
                                </div>
                                <div class="full-width">
                                    <date-picker
                                        v-model="discountTerms.bookingDateTo"
                                        :min="discountTerms.dateFrom || '1900-01-01'"
                                        :label="$t('date_to')"
                                        hide-details
                                    />
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script setup lang="ts">
    import DatePicker from '~/components/snippets/forms/DatePicker.vue'

    const discountTerms = defineModel<any>()
</script>
